var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-navigation-drawer",
    {
      attrs: {
        value: _vm.value,
        "expand-on-hover": !_vm.value,
        permanent: !_vm.value,
        app: ""
      },
      on: {
        input: function($event) {
          return _vm.$emit("input", $event)
        }
      }
    },
    [
      _c(
        "v-list",
        { attrs: { dense: "" } },
        [
          _c(
            "v-list-item",
            { attrs: { link: "", to: { name: "home" } } },
            [
              _c(
                "v-list-item-action",
                [_c("v-icon", [_vm._v("fas fa-home")])],
                1
              ),
              _c(
                "v-list-item-content",
                [
                  _c("v-list-item-title", [
                    _vm._v(_vm._s(_vm.$t("global.menu.home")))
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._t("menu-content")
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }